module.exports = __webpack_public_path__ + "img/schema_tailles_en.0348bc33.png";